import req from "../../methods/req"

//关键数据
export const keyData = function (data) {
    return req({
        url: '/manage/advertising_data/keyData',
        ...data
    })
}

//关键指标趋势图
export const keyTrend = function (data) {
    return req({
        url: '/manage/advertising_data/keyTrend',
        ...data
    })
}

//广告指标明细
export const advertisingIndicatorDetails = function (data) {
    return req({
        url: '/manage/advertising_data/advertisingIndicatorDetails',
        ...data
    })
}

//细分数据
export const subdivisionData = function (data) {
    return req({
        url: '/manage/advertising_data/subdivisionData',
        ...data
    })
}

/**
 * 运营统计日报表
 * @param data
 * @returns {Promise<unknown>}
 */
export const statisticsOperatingCost = function (data) {
    return req({
        url: '/manage/Statistics/getStatisticsOperatingCost',
        ...data
    })
}
export const statisticsOperatingCostCount = function (data) {
    return req({
        url: '/manage/Statistics/getStatisticsOperatingCostCount',
        ...data
    })
}

/**
 * 营收统计日报表
 * @param data
 * @returns {Promise<unknown>}
 */
export const statisticsRevenue = function (data) {
    return req({
        url: '/manage/Statistics/getStatisticsRevenue',
        ...data
    })
}
export const statisticsRevenueCount = function (data) {
    return req({
        url: '/manage/Statistics/getStatisticsRevenueCount',
        ...data
    })
}

/**
 * 现金流出统计日报表
 * @param data
 * @returns {Promise<unknown>}
 */
export const statisticsCashOutflow = function (data) {
    return req({
        url: '/manage/Statistics/getStatisticsCashOutflow',
        ...data
    })
}
export const statisticsCashOutflowCount = function (data) {
    return req({
        url: '/manage/Statistics/getStatisticsCashOutflowCount',
        ...data
    })
}

/**
 * 用户消耗成本及现金报表
 * @param data
 * @returns {Promise<unknown>}
 */
export const statisticsConsumeCash = function (data) {
    return req({
        url: '/manage/Statistics/getStatisticsConsumeCash',
        ...data
    })
}
export const statisticsConsumeCashCount = function (data) {
    return req({
        url: '/manage/Statistics/getStatisticsConsumeCashCount',
        ...data
    })
}